import styled from "styled-components";

export const SettingRowWrapper = styled.div`
  width:auto;
  display:flex;
  padding-bottom: 1.6rem;
  flex-direction: column;
  align-items: stretch;
  gap:0.2rem;
`